export default function ProfileIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 13.3333L8 9.33332M8 9.33332L10 13.3333M8 9.33332V6.66666M4 5.33332L8 6.66666M8 6.66666L12 5.33332M8.66667 3.33332C8.66667 3.70151 8.36819 3.99999 8 3.99999C7.63181 3.99999 7.33333 3.70151 7.33333 3.33332C7.33333 2.96513 7.63181 2.66666 8 2.66666C8.36819 2.66666 8.66667 2.96513 8.66667 3.33332Z"
        stroke="#9CA3AF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
